import { Box, Icon, Spinner, Text } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';

interface DomainSuggestionRowProps {
  domain: string;
  price: string;
  onClick?: () => void;
  onBuyDomain?: (domain: string) => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
}

export function DomainSuggestionRow({
  domain,
  price,
  onClick,
  onBuyDomain,
  disabled = false,
  isLoading = false,
}: Readonly<DomainSuggestionRowProps>) {
  const handleClick = () => {
    if (disabled) return;

    if (onClick) {
      onClick();
      return;
    }

    if (onBuyDomain) {
      onBuyDomain(domain);
    }
  };

  return (
    <DataList.Row onClick={handleClick}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        cursor="pointer"
      >
        <Box display="flex" flexDirection="column">
          <Text fontSize="base" color="neutral-textHigh">
            {domain}
          </Text>
          <Text fontSize="caption" color="neutral-textLow">
            {price}
          </Text>
        </Box>
        {isLoading ? (
          <Spinner size="small" />
        ) : (
          <Icon source={<ChevronRightIcon />} color="primary-interactive" />
        )}
      </Box>
    </DataList.Row>
  );
}
